<mat-calendar #calendar (selectedChange)='select($event)' [dateClass]='dateClass' [minDate]='minDate' [maxDate]='maxDate' [dateFilter]='dateFilter'>
</mat-calendar>
<div class='dates-list'>
    <div class='date-item' *ngFor='let value of daysSelected'>
        {{ toLocalFormat(value) }}
        <mat-icon (click)='select(value)'>cancel</mat-icon>
	</div>
</div>
